import React, { useEffect, useState } from "react";
import {
    Box,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Collapse,
    IconButton,
    Typography,
    Drawer,
    useMediaQuery,
    useTheme,
} from "@mui/material";

import {
    Menu as MenuIcon,
    Dashboard,
    Store,
    Inventory2,
    ShoppingCart,
    ExpandLess,
    ExpandMore,
    AddBox,
    ListAlt,
    Reviews,
    Settings,
    Close,
    ShoppingBag,
    ShoppingBagOutlined,
    HomeOutlined,
    Receipt,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { RootState } from "../Redux/store";
import { useDispatch, useSelector } from "react-redux";
import { setActiveMenue, setOpenSideMenue } from "../Redux/Reducers/globalSlice";
import logo from '../assets/Images/Logo.png'
import { UserRole } from "../types/UserRole";



function SideMenue() {
    const theme = useTheme();

    // Responsive Breakpoints
    const isPhone = useMediaQuery(theme.breakpoints.down("sm"));
    const isMdUp = useMediaQuery(theme.breakpoints.down("xl"));

    const [openSidebar, setOpenSidebar] = useState(isMdUp ? false : true);
    const { openSideMenue, activeMenue, userDetails } = useSelector((state: RootState) => state.global)
    const dispatch = useDispatch()
    const [mobileOpen, setMobileOpen] = useState(openSideMenue);
    const navigate = useNavigate()

    const [openMenu, setOpenMenu] = useState<any>({});
    const [selectedmenue, setselctedMenue] = useState(activeMenue);
    const location = useLocation()
    const userRole: UserRole =
        (userDetails?.role as UserRole) ?? "client";

    // useEffect(() => {
    //     if (isMdUp) {
    //         setOpenSidebar(true); 
    //     }
    // }, [isMdUp]);


    useEffect(() => {
        setselctedMenue(activeMenue)
    }, [activeMenue])

    useEffect(() => {
        const path = location.pathname;
        const menu = path.split("/").pop() || "Dashboard";

        setselctedMenue(menu);
        dispatch(setActiveMenue(menu));
        // const currentMenuList = menuList[role as keyof typeof menuList] || [];

        // const parentMenu = currentMenuList.find((item) =>
        //     item.submenu?.some((subItem) => subItem.value === menu)
        // );

        // if (parentMenu) {
        //     setOpenMenu((prev: any) => ({
        //         ...prev,
        //         [parentMenu.value]: true,
        //     }));
        // }
    }, [location.pathname, dispatch]);

    // console.log("Open Side Menue", openSideMenue)
    console.log("mobile Opne", mobileOpen)
    useEffect(() => {
        setMobileOpen(openSideMenue)
    }, [openSideMenue])

    const menuList = {
        admin: [
            {
                title: "Dashboard",
                value: "dashboard",
                icon: <HomeOutlined />,
            },
            {
                title: "Clients",
                value: "clients",
                icon: <Store />,
            },
            {
                title: "Products",
                value: "products",
                icon: <Inventory2 />,
                // submenu: [
                //     {
                //         title: "All Products",
                //         icon: <ListAlt />,
                //     },
                //     {
                //         title: "Add Product",
                //         icon: <AddBox />,
                //     },
                // ],
            },
        ],
        client: [
            {
                title: "Dashboard",
                value: "dashboard",
                icon: <HomeOutlined />,
            },
            {
                title: "Dealers",
                value: "dealers",
                icon: <Store />,
            },
            {
                title: "Products",
                value: "products",
                icon: <Inventory2 />,
            },
            {
                title: "Orders",
                value: "orders",
                icon: <ShoppingCart />,
                submenu: [
                    {
                        title: "All Orders",
                        value: "all-orders",
                        // icon: <ShoppingBag />,
                    },
                    {
                        title: "Pending Approvals",
                        value: 'pending-approvals'
                        // icon: <AddBox />,
                    },
                ],
            },
            {
                title: "Invoice",
                value: "invoice",
                icon: <Receipt />,
            }
        ],
        subclient: [
            {
                title: "Dashboard",
                value: "dashboard",
                icon: <HomeOutlined />,
            },
            {
                title: "Products",
                value: "products",
                icon: <Inventory2 />,
            },
            {
                title: "Invoice",
                value: "invoice",
                icon: <Receipt />,
            }
        ]

    };

    const handleToggle = (title: string) => {
        setOpenMenu((prev: any) => ({
            ...prev,
            [title]: !prev[title],
        }));
    };
    // Sidebar Content
    const SidebarContent = () => (
        <Box
            className='bg-main h-100 overflow-hidden side-border'
            sx={{
                width: isPhone ? 270 : openSidebar ? 250 : 80,
                transition: "0.3s",
            }}
        >
            {/* Header */}
            <Box
                sx={{
                    maxHeight: '65px',
                    display: "flex",
                    alignItems: "center",
                    justifyContent: (openSidebar || isPhone) ? "space-between" : "center",
                    p: 2,
                    borderBottom: "1px solid rgba(255,255,255,0.08)",
                }}
            >
                {(openSidebar || isPhone) && (
                    <Box className="d-flex align-items-center gap-2">
                        <Box component={'img'} className="bg-white p-1 border-10" src={logo} height={'50px'} alt="logo" />
                        <Box>
                            <Typography
                                variant="body1"
                                className='text-white fw-bold mb-0 pb-0 logo-text' sx={{ lineHeight: 'normal' }}>
                                <span className="text-white">Wholesale</span> <span className="text-main">Pro</span>
                            </Typography>
                            <Typography variant="caption" className="text-white" sx={{ lineHeight: 'normal' }}>{userDetails?.role}</Typography>
                        </Box>
                    </Box>
                )}

                {/* Desktop Toggle */}
                {!isPhone && (
                    <IconButton onClick={() => setOpenSidebar(!openSidebar)}>
                        <MenuIcon sx={{ color: "white" }} />
                    </IconButton>
                )}

                {/* Mobile Close */}
                {isPhone && (
                    <IconButton onClick={() => dispatch(setOpenSideMenue(false))}>
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                )}
            </Box>

            {/* Menu */}
            <List sx={{ p: 1 }}>
                {menuList[userRole].map((item: any, index: number) => (
                    <Box key={index} sx={{ mb: 1 }}>
                        {/* Main Menu */}
                        <ListItemButton
                            onClick={() => {
                                if (item.submenu) {
                                    handleToggle(item.value);
                                } else {
                                    dispatch(setActiveMenue(item.value))
                                    navigate(`/${userRole}/${item.value}`)

                                    if (isPhone) {
                                        dispatch(setOpenSideMenue(false));
                                    }
                                }
                            }}
                            sx={{
                                borderRadius: "8px",
                                mb: 0.5,
                                background:
                                    selectedmenue === item.value
                                        ? "var(--primary-color)"
                                        : "transparent",

                                "&:hover": {
                                    background: selectedmenue === item.value ? "var(--primary-color)" : "var(--primary-light-color)",
                                },
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    color: "white",
                                    minWidth: 40,
                                }}
                            >
                                {item.icon}
                            </ListItemIcon>

                            {(openSidebar || isPhone) && (
                                <>
                                    <ListItemText
                                        className="fs-14 text-white"
                                        primary={item.title}
                                    />

                                    {item.submenu &&
                                        (openMenu[item.value] ? (
                                            <ExpandLess sx={{ color: "white" }} />
                                        ) : (
                                            <ExpandMore sx={{ color: "white" }} />
                                        ))}
                                </>
                            )}
                        </ListItemButton>

                        {/* Submenu */}
                        {(item.submenu || openMenu[item.value]) &&
                            (
                                <Collapse
                                    in={openMenu[item.value] && (openSidebar || isPhone)}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    <List component="div" disablePadding>
                                        {item.submenu.map(
                                            (subItem: any, subIndex: number) => (
                                                <ListItemButton
                                                    className="mx-1 ms-4  mb-2"
                                                    key={subIndex}
                                                    onClick={() => {
                                                        dispatch(setActiveMenue(subItem.title))
                                                        navigate(`/${userRole}/${subItem.value}`)
                                                        if (isPhone) {
                                                            dispatch(setOpenSideMenue(false))
                                                        }
                                                    }}
                                                    sx={{
                                                        borderRadius: "8px",
                                                        background:
                                                            selectedmenue === subItem.value
                                                                ? "var(--primary-color)"
                                                                : "transparent",

                                                        "&:hover": {
                                                            background: selectedmenue === subItem.value ? "var(--primary-color)" : "var(--primary-light-color)",
                                                        },
                                                    }}
                                                >

                                                    <ListItemText
                                                        className="fs-14 text-white"
                                                        primary={subItem.title}
                                                    />
                                                </ListItemButton>
                                            )
                                        )}
                                    </List>
                                </Collapse>
                            )}
                    </Box>
                ))}
            </List>
        </Box>
    );

    return (
        <>
            {/* Mobile Topbar */}
            {/* {isPhone && (
        <Box
          sx={{
            height: 65,
            background: "#111827",
            display: "flex",
            alignItems: "center",
            px: 2,
            justifyContent: "space-between",
          }}
        >
          <IconButton onClick={() => dispatch(setOpenSideMenue(true))}>
            <MenuIcon sx={{ color: "white" }} />
          </IconButton>
        </Box>
      )} */}

            {/* Desktop Sidebar */}
            {!isPhone && (
                <Box
                    sx={{
                        position: "sticky",
                        top: 0,
                        height: "100vh",
                    }}
                >
                    <SidebarContent />
                </Box>
            )}

            {/* Mobile Drawer */}
            {isPhone && (
                <Drawer
                    anchor="left"
                    open={mobileOpen}
                    onClose={() => dispatch(setOpenSideMenue(false))}
                >
                    <SidebarContent />
                </Drawer>
            )}
        </>
    );
}

export default SideMenue;